<template>
    <base-spinner :open="isloading"></base-spinner>
    <div class="products-view__list products-list products-list--grid--4" data-layout="table" data-with-features="false">
        <div class="products-list__head">
            <div class="products-list__column products-list__column--image">Image</div>
            <div class="products-list__column products-list__column--qty">QTY</div>
            <div class="products-list__column products-list__column--product">Product</div>
            <!-- <div class="products-list__column products-list__column--information">Information</div> -->
            <div class="products-list__column products-list__column--availability" v-if="!isKit">Availability</div>
            <div class="products-list__column products-list__column--price">Price</div>
        </div>
        <div class="products-list__content">
            <div style="width: 100%">
                <results-product-item 
                v-for="(product, indx) in displayedParts"
                :key="product.ID"
                :index='indx'
                :product="product"
                :source-page="'SearchResults'"
                :searchBy="searchBy"
                :productValid="true">
                </results-product-item>
            </div>
        </div>
    </div>
</template>

<script>
import ResultsProductItem from '../searchresults/ResultsProductItem.vue';
// import ResultsKitItem from '../searchresults/ResultsKitItem.vue';
import axiosvl from "../../../axios/axios-vl.js";
import axios from 'axios';
import SolrHelper from '../../../mixins/solr_helper';
import { mapGetters } from 'vuex';
import * as GCONST from '../../../constants.js';

export default {
    components : {
        ResultsProductItem,
        // ResultsKitItem
    },
    props : {
        level : {
            type: Number,
        },
        categoryUri1: {
            type: String,
            required: true
        },
        perPage : {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        filter_price: {
            type: String,
        },
        filter_availability: {
            type: String,
        },
    },
    emits: ['clear_messages', 'show_messages', 'total_items', 'total_showing'],
    data() {
        return {
            parts : [],
            partslen: 0,
            page : 1,
            isloading: false,
            pages: [],
            searchBy: 'QO',
            isKit: false,

            numFound: 0,
            facets: {},
            facet_field_uri: '',

            more_filters: [],
            last_filter: null,
        }
    },
    computed: {
        ...mapGetters(['customerIndicator']),

        displayedParts () {
            let nProd = this.parts;
            // console.log(this.parts);

            if(this.filter_price == 'HighToLow'){
                nProd.sort((a,b) => (a.extended_price < b.extended_price) ? 1 : ((b.extended_price < a.extended_price) ? -1 : 0));
            }
            
            if(this.filter_price == 'LowToHigh'){
                nProd.sort((a,b) => (a.extended_price > b.extended_price) ? 1 : ((b.extended_price > a.extended_price) ? -1 : 0));
            }

            // nProd.sort((a,b) => (a.stockquantity < b.stockquantity) ? 1 : ((b.stockquantity < a.stockquantity) ? -1 : 0));

            this.$emit('total_showing', nProd.length);
            return nProd;
        },
    },
    watch: {
        level() {
            this.solr_search();
        },
        parts () {
            this.setPages();
        },
        categoryUri1: function() {
            // console.log('category changed');
            // this.solr_search();
        }
    },
    mixins: [ SolrHelper ],
    methods: {
        async solr_search(filters = null, currentPage = 1) {
            console.log(filters);
            const rows = this.perPage;
            const start = this.perPage * (currentPage - 1);
            // const custom_attr = this.$store.getters['product/custom_attrs'];
            const catCode = this.$route.params.categoryUri1;
            
            this.$emit('clear_messages');
            this.parts = [];
            this.more_filters = [];
            this.isloading = true;

            let filter_uri = '';
            // console.log(this.$route.query);

            if(filters != null){
                filter_uri = this.mx_multi_facet_filter(filters);
            }else{
                // defaults filter search
                filter_uri = '&fq=Stocks:[1 TO *]';
            }
            
            let lvl = 1;
            while(lvl <= this.level){
                filter_uri += '&fq=DMCD0'+lvl+':' + this.$route.params['categoryUri' + lvl];
                lvl += 1;
            }
            filter_uri += this.mx_get_filter();

            // const uri = 'http://localhost:8983/solr/dms_products/select?facet.field=Color&facet=true&indent=true&q.op=OR&q=Item%3A*'+this.keyword+'*';
            const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
            let uri = solr_host + '/select?q.op=AND&q=DMCD01%3A'+catCode+'&facet.field=IGDESC&facet.field=MCNAME&facet=true&f.B2C_price.facet.range.start=0&f.B2C_price.facet.range.end=1000&f.B2C_price.facet.range.gap=100&facet.range=B2C_price&f.Weight.facet.range.start=0&f.Weight.facet.range.end=100&f.Weight.facet.range.gap=10&facet.range=Weight&group=true&group.field=Item&group.facet=true&group.format=simple&group.ngroups=true';
            let paginate_uri = '&rows=' + rows+ '&start=' + start;
            // const sorting_uri = '&sort=Stocks%20desc,%20Stocking_Flag%20desc';

            uri += filter_uri + this.facet_field_uri + paginate_uri;

            await axios.get(uri,{
                auth: {
                    username: this.$store.getters.solr_username,
                    password: this.$store.getters.solr_password
                }
            })
            .then((response) => {
                const MPARTS = response.data.grouped.Item.doclist.docs;
                const resp_facets = response.data.facet_counts;
                // console.log(resp_facets);
                this.facets = resp_facets;
                this.numFound  = response.data.grouped.Item.ngroups;

                MPARTS.forEach(obj => {
                    this.getProductDetails(obj);
                });
                
                this.$emit('facet_keys', this.facets);

                this.$emit('total_items', this.numFound);
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        searchParts() {
            this.$emit('clear_messages');
            this.parts = [];
            this.isloading = true;
            
            axiosvl.post(this.$store.getters['api/search_parts_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer },
                        "SEARCH": {"value": this.keyword },
                        "SHOW0OH": {"value": "Y" },
                        "SKIPN": {"value": 0 },
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields

                if (fields.RESULTCOD.value === 'OK') {
                    const MPARTS = response.data.webroutine.lists.MPARTS.entries;
                    // console.table(MPARTS);

                    if(MPARTS.length > 0){
                        // hardcoded for kit item
                        // need to identify how product being parts or a kit
                        if(MPARTS[0].IMKITM == 'Y'){
                            this.isKit = true;
                        }else{
                            this.isKit = false;
                        }
                    }
                    this.$emit('isKit', this.isKit);

                    for (const key in MPARTS) {
                        const obj = MPARTS[key];
                        const clearProductDesc = encodeURIComponent(obj.MCNAME);

                        this.parts.push({
                            manufacturer: obj.EIMFGC,
                            sku: obj.EIITMC,
                            customer: obj.CMCUST,
                            location: obj.CMDLOC,
                            IMMFGC: obj.IMMFGC,
                            manufacturerdesc: obj.MCNAME,
                            IMITMC: obj.IMITMC,
                            description: obj.IMDESC,
                            XRMFGC: obj.XRMFGC,
                            XRITMC: obj.XRITMC,
                            DEDESC: obj.DEDESC,
                            IMIGSA: obj.IMIGSA,
                            IMISVALID: obj.IMISVALID,
                            mfgSeo: obj.IMDESC.replace(/ /g, "-"),
                            itemSeo: clearProductDesc.replace(/ /g, "-"),
                            // !NC! image: obj.EPIMG1,
                            image: GCONST.THUMB_IMAGE_PLACEHOLDER,

                            // from Nic @ issue #260
                            // if it is B2B use QTYAVL
                            // if it is B2C use TOTOH
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? obj.QTYAVL : obj.TOTOH,
                            stockqty: obj.QTYAVL,
                            list_price: obj.EILSTP,
                            extended_price: obj.EIEXCP,
                            core_charge: obj.EICORP,
                        });
                    }
                    this.partslen = response.data.webroutine.lists.MPARTS.entries.length;
                    // console.log(this.partslen);
                    this.$emit('total_items', this.partslen);
                } else {
                    const messages = [];
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    this.$emit('show_messages', messages);
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        setPages () {
            this.pages = [];
            let numberOfPages = Math.ceil(this.numFound / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },

        // paginate (parts) {
        //     let page = this.currentPage;
        //     let perPage = this.perPage;
        //     let from = (page * perPage) - perPage;
        //     let to = (page * perPage);

        //     const sliced = parts.slice(from, to);
        //     this.$emit('total_showing', sliced.length);

        //     return sliced;
        // },

        // get product details from the web service
        async getProductDetails(product){
            // console.log(product);
            // console.log(image);
            await axiosvl.post(this.$store.getters['api/product_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },   
                    "fields": {
                        "EHCUST": { "value": this.$store.getters['customer'] },
                        "EIMFGC": { "value": product.DXMFGC },
                        "EIITMC": { "value": product.Item },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {
                    // console.log(fields);
                    // const linetotal = 1 * fields.EIEXCP.value;
                    const defaultLoc = this.$store.getters.getCustomerDetails;
                    const clearProductDesc = encodeURIComponent(product.Item_Desc);

                    this.parts.push({
                        manufacturer: product.DXMFGC,
                        sku: product.Item,
                        // customer: obj.CMCUST,
                        location: defaultLoc,
                        IMMFGC: product.DXMFGC,
                        manufacturerdesc: product.MCNAME,
                        IMITMC: product.Item,
                        description: product.Item_Desc,
                        XRMFGC: '',
                        XRITMC: '',
                        DEDESC: '',
                        IMIGSA: product.IGCODE_SAG,
                        IMISVALID: '',
                        mfgSeo: product.MCNAME.replace(/ /g, "-"),
                        itemSeo: clearProductDesc.replace(/ /g, "-"),
                        // !NC! image: obj.EPIMG1,
                        image: product.Image,

                        // from Nic @ issue #260
                        // if it is B2B use QTYAVL
                        // if it is B2C use TOTOH
                        // stockquantity: (this.$store.getters.customerIndicator == 'B') ? fields.QTYAVL.value : fields.TOTOH.value,
                        stockquantity: product.Stocks,
                        // stockquantity: 1,
                        // stockqty: 1,
                        list_price: fields.EILSTP.value,
                        extended_price: fields.EIEXCP.value,
                        core_charge: fields.EICORP.value,
                    });

                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
            });
        },

    },
    async created() {
        // await this.solr_search();
    },

    updated() {
        
        // console.log(this.$route.query);
        
        // if(this.last_filter != this.$route.query){
            // console.log('uri updated');
            // this.solr_search(true);
            // this.last_filter = this.$route.query;
            // this.$refs.keywords_list.solr_search(true);
        // }
        // this.$refs.keywords_list.solr_search();
    }
    // updated() {
    //     console.log('updated - ' + this.keyword);
    //     this.searchParts();
    // }

}
</script>
    
